import { useDispatch } from "react-redux";
import { apartmentStepSet } from "../../../../redux/slice/apartmentRental/apartmentRentalSlice";
import { BookingCreationStep } from "../bookingCreationStep";
import ListLoadError from "./ListLoadError";

/**
 * What an object's overview shows when its details could not be loaded.
 *
 * Without it the overview rendered as if the object simply had nothing to
 * show — "Keine Bilder vorhanden", no description, no amenities — which is a
 * failure dressed up as an absence (#2764). The way on is back to the list,
 * which the shell re-searches on that step, so the customer can pick again.
 */
const ObjectDetailsFailure = () => {
  const dispatch = useDispatch();
  return (
    <ListLoadError
      messageKey="book_location.error.fetch_object_details"
      action={{
        labelKey: "book_location.error.back_to_list",
        onClick: () =>
          dispatch(apartmentStepSet(BookingCreationStep.apartmentSelection)),
      }}
    />
  );
};

export default ObjectDetailsFailure;
